import React, { useState, useRef, useEffect } from 'react'
import Resumes from "../resumetemplates/Resumes";
// import { connect } from 'react-redux';
import PreviewIcon from '../../assets/images-new/icons/visibility.svg';
import { BREADCRUMB_LINKS, FINAL_RESUME, REARRANGE_LINK } from '../../constants/constants';
import { useResume } from '../../context/ResumeContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { removeBodyScroll } from '../../helper';
import { useResumePreviewSize } from '../common/useResumePreviewSize';

const RightSection = (props) => {
    // State to track if the window is blurred
    const [isWindowBlurred, setIsWindowBlurred] = useState(false);
    const [width, height, scale] = useResumePreviewSize();
    const { 
        resume,
        showPreview, 
        setShowPreview 
    } = useResume();
    // //const [fullscreen, setFullScreen] = useState(false);
    const [tooltip, showToolTip] = useState(false);
    const [tttxt, setTttxt] = useState('');
    const history = useHistory();
    const changeTooltip = () => {
        Object.keys(BREADCRUMB_LINKS).map(function (key, index) {
            if (document.location.pathname == BREADCRUMB_LINKS[key].link) {
                setTttxt(BREADCRUMB_LINKS[key].tooltip)
                showToolTip(true)
            }
        })
    }
    const closeOverLay = (e) => {
        if (e.target.className == 'right right__fullscreen') {
            setShowPreview(!showPreview);
            removeBodyScroll(false);
        }
        e.stopPropagation();
    }

    const rdRef = useRef(null);

    useEffect(() => {
        // Handle window blur event
        const handleWindowBlur = () => {
          setIsWindowBlurred(true);
        };
      
        // Handle window focus event
        const handleWindowFocus = () => {
          setIsWindowBlurred(false);
        };
      
        // Handle scroll event
        const handleScroll = () => {
          setIsWindowBlurred(false);
        };

        // Handle right-click event
        const handleContextMenu = (e) => {
            e.preventDefault();
        }
      
        // Add event listeners for blur and focus
        window.addEventListener("blur", handleWindowBlur);
        window.addEventListener("focus", handleWindowFocus);
      
        const scrollRdDiv = rdRef.current;
      
        // Add scroll event listener on resume-donwload container
        if (scrollRdDiv) {
            scrollRdDiv.addEventListener("scroll", handleScroll);
        }

        // Disable right-click
        window.addEventListener("contextmenu", handleContextMenu);

        // Handle tab switch or the browser minimize
        window.addEventListener('visibilitychange', function () {
            // User switched tabs or minimized the browser
            if (document.visibilityState === 'hidden') {
              handleWindowBlur();
            } 
            // User returned to the tab
            else if (document.visibilityState === 'visible') {
              setTimeout(() => {
                handleWindowFocus();
              }, 1000);
            }
        });
      
        // Cleanup event listeners on component unmount
        return () => {
          window.removeEventListener("blur", handleWindowBlur);
          window.removeEventListener("focus", handleWindowFocus);
          window.removeEventListener('contextmenu', handleContextMenu);
      
          if (scrollRdDiv) {
            scrollRdDiv.removeEventListener("scroll", handleScroll);
          }
        };
    }, []);      

    return (
        <div id="rightEditor" className={showPreview ? `right right__fullscreen` : `right`} onClick={(e) => { 
            closeOverLay(e);
        }}>
            {showPreview ? <div className="close-wrap" onClick={() => { setShowPreview(!showPreview), removeBodyScroll(false) }}>
                <i>Close</i>
            </div> : ''}
            <div ref={rdRef} id="resume-download" className={`${isWindowBlurred ? 'blurred' : ''}`}>
                <div className="paper preview-resume" id="preview-resume">
                    <div id="resume-page" className="page">
                        {<Resumes data={props.resume} scale={scale} />}
                    </div>
                </div>
            </div>
            {(!(window.location.pathname).includes('allinone') && window.location.pathname != REARRANGE_LINK)
            && <div className="bottom-btn-control">
                    {/* <div className="button button-1">
                        <div className="change-templ-action">
                            <span onClick={() => {
                                ga4Track('app_bottom_nav_templates', 'RB App', 'Bottom Nav: Templates');
                                localStorage.setItem('referrer', window.location.pathname);
                                history.push({
                                    pathname: FINAL_RESUME,
                                    state: {
                                        openPanel: true
                                    }
                                })
                            }}><i className="icon-grid"></i>Templates</span>
                        </div>
                    </div> */}
                    <div className="button button-1">&nbsp;</div>
                    <div className="btn-group-preview">
                        <button
                            type="button"
                            className="round-btn round-btn-border"
                            onClick={(e) => {
                                setShowPreview(!showPreview);
                                removeBodyScroll(true);
                                gaTrack('RB App', `Editor`, 'Preview');
                                ga4Track('app_editor_preview', 'RB App', 'Preview');
                                ga4Track('app_bottom_nav_preview', 'RB App', 'Bottom Nav: Preview');
                            }}>
                            <i className="new-icon-eye"><PreviewIcon /></i>
                            Preview
                        </button>
                    </div>
                </div>
            }
        </div>
    );

};

export default RightSection;
